import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Menu = () => {
    // State to track active menu item
    const [activeItem, setActiveItem] = useState('');
    const location = useLocation();

    // Function to handle click on menu items
    const handleItemClick = (itemName) => {
        setActiveItem(itemName);
    };

    // Set active item based on the current location path
    useEffect(() => {
        const currentPath = location.pathname;
        const currentItem = currentPath === '/' ? 'about' : currentPath.slice(1).toLowerCase();
        setActiveItem(currentItem);
    }, [location]);

    // CSS for active and default states
    const menuStyle = {
        display: 'block',
        float: 'right'
    };

    const activeStyle = {
        backgroundColor: '#f0f0f0',  // Background color for active item
        padding: '10px'
    };

    return (
        <div className="text-right mt-3">
            <div className="bostami-main-menu-wrap">
                <nav className="bastami-main-menu main_menu_3" style={menuStyle}>
                    <ul>
                        <li className={activeItem === 'about' ? 'active' : ''} style={activeItem === 'about' ? activeStyle : {}}>
                            <Link to="/" onClick={() => handleItemClick('about')}>
                                <span><i className="fa fa-address-card-o"></i></span>
                                About
                            </Link>
                        </li>
                        <li className={activeItem === 'profile' ? 'active' : ''} style={activeItem === 'profile' ? activeStyle : {}}>
                            <Link to="/Profile" onClick={() => handleItemClick('profile')}>
                                <span><i className="fa fa-id-badge"></i></span>
                                Profile
                            </Link>
                        </li>
                        <li className={activeItem === 'projects' ? 'active' : ''} style={activeItem === 'projects' ? activeStyle : {}}>
                            <Link to="/Projects" onClick={() => handleItemClick('projects')}>
                                <span><i className="fa fa-briefcase"></i></span>
                                Projects
                            </Link>
                        </li>
                        <li className={activeItem === 'awards' ? 'active' : ''} style={activeItem === 'awards' ? activeStyle : {}}>
                            <Link to="/Awards" onClick={() => handleItemClick('awards')}>
                                <span><i className="fa fa-trophy"></i></span>
                                Awards
                            </Link>
                        </li>
                        <li className={activeItem === 'socialwelfare' ? 'active' : ''} style={activeItem === 'socialwelfare' ? activeStyle : {}}>
                            <Link to="/Socialwelfare" onClick={() => handleItemClick('socialwelfare')}>
                                <span><i className="fa fa-handshake-o"></i></span>
                                Social<br /> Welfare
                            </Link>
                        </li>
                        <li className={activeItem === 'blog' ? 'active' : ''} style={activeItem === 'blog' ? activeStyle : {}}>
                            <Link to="/Blog" onClick={() => handleItemClick('blog')}>
                                <span><i className="fa fa-clone"></i></span>
                                Blogs
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    );
}

export default Menu;
